import { render, staticRenderFns } from "./QuotasPerInventoryChart.vue?vue&type=template&id=2e303570&scoped=true"
import script from "./QuotasPerInventoryChart.vue?vue&type=script&lang=js"
export * from "./QuotasPerInventoryChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e303570",
  null
  
)

export default component.exports